export const removeSlash = (str: string | null | undefined): string => {
    if (!str) {
        console.warn("Input is null or undefined. Returning an empty string.");
        return "";
    }
    return str.startsWith('/') ? str.slice(1) : str;
};

export const capitalizeFirstLetter = (str: string | null | undefined): string => {
    if (!str) {
        console.warn("Input is null or undefined. Returning an empty string.");
        return "";
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const setPageTitle = (title: string | null | undefined): void => {
    if (!title) {
        console.warn("Title is null or undefined. Setting the default title.");
        document.title = "HFF Donors";
        return;
    }
    document.title = title + " | HFF Donors";
};

export const validatePhoneNumber = (phone: string) => {
    // Remove all non-digit characters
    const digitsOnly = phone.replace(/\D/g, '');

    // Check if the number has exactly 10 digits
    return digitsOnly.length === 10;
};

export const getAppType = () => {
    return localStorage.getItem("type") || "hff";
};

